"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var crypto = require("crypto");
var ON = '1';
var BYTE_TO_7_BIT = 7;
var CP_CODE_BIT = 10;
var ALGORITHM = 'aes-128-ecb';
var DECRYPTED_KEY = '6b7devzhb_ku4nr1';
exports.isLocationAgreed = function (nidCpCode) {
    if (!nidCpCode)
        return false;
    var decodedBytes = new Buffer(nidCpCode, 'base64');
    var bytes = new Uint8Array(decodedBytes);
    var binaryString = bytes.reduce(function (acc, byte) {
        return "" + Array.from({ length: BYTE_TO_7_BIT }, function (v, i) { return BYTE_TO_7_BIT - 1 - i; }).reduce(function (acc2, num) { return "" + acc2 + ((byte >>> num) & 1); }, '') + acc;
    }, '');
    return binaryString.charAt(binaryString.length - CP_CODE_BIT) === ON;
};
exports.decryptLocationCookie = function (encryptedMLoc) {
    if (!encryptedMLoc)
        return null;
    var decipher = crypto.createDecipheriv(ALGORITHM, DECRYPTED_KEY, '');
    return "" + decipher.update(encryptedMLoc, 'hex', 'utf8') + decipher.final('utf8');
};
//# sourceMappingURL=location.js.map